"use client";

import { Spinner as HeroSpinner } from "@heroui/react";
import { cn } from "../../lib/utils";

export const Spinner = ({ className, ...props }: { className?: string } & React.ComponentProps<typeof HeroSpinner>) => {
  // HeroUI puts aria-label="Loading" on the wrapper but no role, which axe flags
  // (aria-prohibited-attr). role="img" makes the label valid; we avoid role="status"
  // so the spinner doesn't collide with the app's <output>/role=status messages.
  // role is set after the spread so a caller can't accidentally drop it and
  // reintroduce the violation this wrapper exists to fix.
  return <HeroSpinner className={cn(className)} {...props} role="img" />;
};
